<div class="input-group" *ngIf="maskDateOfBirth">
    <input type="text" class="form-control" value="**/**/****" [disabled]="true">

    <span class="input-group-addon" *ngIf="person.dateOfBirth && person.age">
       {{person.age}} years old
    </span>
</div>

<div *ngIf="!maskDateOfBirth">
    <div class="input-group">
        <input type="text" class="form-control" data-view="years" ngModel [floRequiredIf]="required"
               placeholder="mm/dd/yyyy" floDateTimePicker name="dob" #dob="ngModel"
               [(date)]="person.dateOfBirth" (dateChange)="onDateOfBirthChange()">

        <span class="input-group-addon" *ngIf="person.dateOfBirth && person.age">
           {{person.age}} years old
        </span>
    </div>

    <div *ngIf="!dob.valid && (!dob.pristine || isSubmitted)" class="validation-error">
        Invalid Date of Birth
    </div>
</div>